<template>
  <b-modal
    v-model="show"
    centered
    size="md"
    :no-close-on-backdrop="submitting"
    :no-close-on-esc="submitting"
    @hidden="onHidden"
  >
    <template #modal-title>
      <h3 class="font-weight-bold">Reject this file?</h3>
    </template>

    <b-form-group
      label="Reason for rejection"
      label-for="reject-reason"
      label-class="font-weight-bold"
    >
      <template #label>
        Reason for rejection <span class="text-danger">*</span>
      </template>
      <b-form-textarea
        id="reject-reason"
        v-model="reason"
        rows="4"
        max-rows="8"
        placeholder="Let the tradie know what needs to change"
        :state="reasonState"
        :disabled="submitting"
        aria-describedby="reject-reason-feedback"
      />
      <b-form-invalid-feedback id="reject-reason-feedback">
        {{ errorMessage }}
      </b-form-invalid-feedback>
    </b-form-group>

    <template #modal-footer>
      <div class="d-flex justify-content-end" style="gap: 12px">
        <b-button
          variant="secondary"
          :disabled="submitting"
          @click="closeDialog"
        >
          Cancel
        </b-button>
        <b-button variant="danger" :disabled="!canSubmit" @click="onConfirm">
          <b-spinner v-if="submitting" small label="Submitting" />
          <span v-else
            >Reject<span class="d-none d-sm-inline"> file</span></span
          >
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'RejectFileModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    fileName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      reason: '',
      submitting: false,
      errorMessage: '',
    }
  },

  computed: {
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.closeDialog()
      },
    },
    trimmedReason() {
      return (this.reason || '').trim()
    },
    canSubmit() {
      return !this.submitting && this.trimmedReason.length > 0
    },
    reasonState() {
      if (this.errorMessage) return false
      return null
    },
  },

  watch: {
    showModal(val) {
      if (val) {
        this.reason = ''
        this.errorMessage = ''
        this.submitting = false
      }
    },
  },

  methods: {
    closeDialog() {
      if (this.submitting) return
      this.$emit('close')
    },

    onHidden() {
      this.reason = ''
      this.errorMessage = ''
      this.submitting = false
    },

    onConfirm() {
      if (!this.canSubmit) return
      this.submitting = true
      this.errorMessage = ''
      this.$emit('confirm', {
        reason: this.trimmedReason,
        done: (err) => {
          this.submitting = false
          if (err) {
            const payload = err && err.response && err.response.data
            if (err && err.response && err.response.status === 422) {
              this.errorMessage =
                (payload && (payload.message || payload.error)) ||
                'Please provide a valid reason.'
              return
            }
            this.errorMessage =
              (payload && payload.message) ||
              (err && err.message) ||
              'Could not reject file.'
            return
          }
          this.$emit('close')
        },
      })
    },
  },
}
</script>
